// API endpoints for fetching exchange data and icons that were provided
export const getExchangeDataApi = "https://rest.coinapi.io/v1/exchanges"
export const getExchangeIconApi = "https://rest.coinapi.io/v1/exchanges/icons/32"

// API endpoint for adding exchange data and icons from the Created DB
export const addExchangeData = "/addExchangeData"
export const addExchangeIcon = "/addExchangeIcon"

